// jQuery is provided globally via webpack.ProvidePlugin
import 'jquery';
// video.js - expose as global
import videojs from 'video.js';
window.videojs = videojs;
// Import videojs plugins and register them
import 'videojs-hotkeys';
// videojs-contrib-eme needs explicit registration
import 'videojs-contrib-eme';
// Angular and plugins - jQuery must be available before these load
import 'angular';
import 'angular-mocks';
import 'angular-sanitize';
import 'angular-material';
import 'angular-animate';
import 'angular-aria';
import 'angular-route';
import 'angular-filter';
import 're-tree';
import 'ng-device-detector';
// Masonry - expose as global and attach to jQuery
import Masonry from 'masonry-layout';
window.Masonry = Masonry;
// jQuery Bridget to make Masonry work as jQuery plugin
import jQueryBridget from 'jquery-bridget';
jQueryBridget('masonry', Masonry, window.jQuery);
import 'angular-material/angular-material.css';
import 'video.js/dist/video-js.css';
